import { render, staticRenderFns } from "./OwnOffersManualExportPlatforms.vue?vue&type=template&id=f5d36756&"
import script from "./OwnOffersManualExportPlatforms.vue?vue&type=script&lang=js&"
export * from "./OwnOffersManualExportPlatforms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports